export default __webpack_public_path__ + "static/NewsCard-dc989d5c8c323e0ed9f8137a9995e1b0.png";